import { render, staticRenderFns } from "./ClientTSRs.vue?vue&type=template&id=1614ffee"
import script from "./ClientTSRs.vue?vue&type=script&lang=js"
export * from "./ClientTSRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports